__turbopack_context__.v({
  "black": "Stars-module__q44CFa__black",
  "icon": "Stars-module__q44CFa__icon",
  "iconLarge": "Stars-module__q44CFa__iconLarge",
  "iconSmall": "Stars-module__q44CFa__iconSmall",
  "iconXS": "Stars-module__q44CFa__iconXS",
  "iconXXS": "Stars-module__q44CFa__iconXXS",
  "icons": "Stars-module__q44CFa__icons",
  "yellow": "Stars-module__q44CFa__yellow",
});
